import React, { useCallback, Suspense, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { status } from 'skin/event/status';
import { Cnt } from 'skin/context';
import './style.css';

import Content from 'skin/form/content';
import Head from './head';
import Loading from 'skin/cmp/loading';

import form from 'skin/store/form';
import data from 'skin/store/form/data';

import user from 'task/store/action/form';
import story from 'skin/store/form/story';
import act from './act';
import m from 'skin/store/mb';

// Ленивая загрузка
const Func = React.lazy((_) => import('skin/form/func'));

const Form = (props) => {
	const mb = m.isMobile;
	const d = JSON.stringify(props.data);
	const code = props.data.code;

	// Пользовательский action
	const userAct = useCallback(
		(obj, form, story, data, d, action) => {
			const fnc = user.s[code] ? user.s[code] : user.s.def;
			return fnc(obj, form, story, data, d, action);
		},
		[code]
	);

	// Стандартный action Формы по key
	const action = useCallback(
		(obj) => {
			// Выполнение пользовательских action из task/store/action/form
			const val = userAct(obj, form, story, data, d, action);
			if (val === status.ignore) return status.action;
			// Выполнение action по умолчанию
			if (act[obj.type]) act[obj.type](obj, form, data, story, action, d);
			return status.action;
		},
		[userAct, d]
	);
	useEffect(newCode, [d, action]);

	// Горячие клавиши
	useEffect(() => {
		// Сохранение формы
		const key = ['s', 'S', 'ы', 'Ы'];
		const onKeydown = (e) => {
			if (e.ctrlKey && key.includes(e.key)) {
				e.preventDefault();
				action({ type: 'control', action: 'save' });
			}
		};
		document.addEventListener('keydown', onKeydown);
		return () => document.removeEventListener('keydown', onKeydown);
	}, [action]);

	let cls = ['skin-form', 'form'];
	cls = cls.join(' ');

	// Заголовок формы
	const title = form.s?.book?.title
		? form.s.book.title
		: 'Форма <не определена>';
	const func = form.s?.func ?? {};

	// массив страниц
	const pages = form.s?.page?.list ? form.s.page.list : [];
	// кол-во страниц для формы
	const pgCount = form.count;

	const current = story.current;
	// Определяем текущую страницу

	const content = func?.on ? (
		<Suspense fallback={Loading()}>
			<Func func={func} action={action} />
		</Suspense>
	) : (
		<Content />
	);
	return (
		<div
			className={cls}
			data-info-title={'Данные по форме ' + d}
			data-info={`title = ${title}; current = ${JSON.stringify(
				current
			)}; pageCount = ${pgCount}`}
		>
			<Cnt.Provider
				value={{
					action,
					title,
					func,
					pages,
					pgCount,
					current,
				}}
			>
				{ ((!mb) || (!func.on && mb)) && <Head  />}
				{content}
			</Cnt.Provider>
		</div>
	);

	// Новый код формы
	function newCode() {
		form.getDef(d, action, story);
	}
};

export default observer(Form);
